module.exports = __webpack_public_path__ + "static/img/encourage-bg.3c5e22c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/study/statistics/encourage-bg.png
// module id = oH1f
// module chunks = 96